import { Radio } from './radio'

export class MixRadio {
	public id: number
	public mixId: number
	public radioId: number
	public mixPercentage: number
	public rrule: string | null
	public isDefault: boolean

	public radio?: Radio

	constructor(data: {
		id: number
		mixId: number
		radioId: number
		mixPercentage: number
		rrule: string | null
		isDefault: boolean
		radio?: Radio
	}) {
		this.id = data.id
		this.mixId = data.mixId
		this.radioId = data.radioId
		this.mixPercentage = data.mixPercentage
		this.rrule = data.rrule
		this.isDefault = data.isDefault
		this.radio = data.radio
	}

	static create(data: Partial<MixRadio>): MixRadio {
		const defaultData = {
			id: 0,
			mixId: 0,
			radioId: 0,
			mixPercentage: 0,
			rrule: null,
			isDefault: false,
			radio: undefined,
		}

		return new MixRadio({
			...defaultData,
			...data,
		})
	}
}
